module.exports = __webpack_public_path__ + "static/media/slide1.64974237.png";